var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "name_icon",
    transform: "translate(-317 -1289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2659",
    "data-name": "Path 2659",
    d: "M26,0H0V26H26Z",
    transform: "translate(317 1289)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2658",
    "data-name": "Path 2658",
    d: "M17.982,18.725a7.5,7.5,0,0,0-11.964,0m11.963,0a9,9,0,1,0-11.963,0m11.963,0a9,9,0,0,1-11.963,0M15,9.75a3,3,0,1,1-3-3A3,3,0,0,1,15,9.75Z",
    transform: "translate(317.502 1290.5)",
    fill: "none",
    stroke: "#52555e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameIcon);
export default __webpack_public_path__ + "static/media/name_icon.04694c5ceb09c3bdc50769d350c91544.svg";
export { ForwardRef as ReactComponent };